import React from "react";
import { Outlet } from "react-router-dom";
import SubAdminSidebar from "../components/SubAdmin/SubAdminSidebar";
import SubAdminNavbar from "../components/SubAdmin/SubAdminNavbar";

function SubAdminLayout() {
  return (
      <div className="flex h-screen w-full">
          {/* Sidebar */}
          <div className="fixed left-0 top-0 hidden h-screen w-64 bg-white lg:block">
              <SubAdminSidebar />
          </div>
          {/* Main Content */}
          <div className="flex min-w-[960px] flex-1 flex-col lg:ml-64">
              {/* Navbar (Fixed at Top) */}
              <div className="fixed right-0 top-0 z-10  bg-white lg:left-64">
                  <SubAdminNavbar />
              </div>
              {/* Scrollable Outlet Content */}
              <div className="mt-16 flex-1 overflow-y-auto p-6">
                  <Outlet />
              </div>
          </div>
      </div>
  )
}

export default SubAdminLayout